import { Button, Tree, Input } from 'antd';
import React, { Component, Fragment } from 'react';
import Panel from '@/components/Panel';
import { createPortal } from 'react-dom';
import auroraDBJson from '../../services/Designs/auroraDbData';
import { splitArrayToArrays } from '../../services/helper/arrayHelper';
import './index.css';

class PortImport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      treeData: [],
      displayTree: [],
      value: []
    };
    this.dialogRoot = document.getElementById('root');
  }

  componentDidMount = () => {
    this.generateData()
  }

  generateData = () => {
    const { designId, importData } = this.props;
    const components = auroraDBJson.getComponents(designId);
    const treeData = [...components.values()].map(item => {
      return {
        title: item.name,
        key: item.name,
        children: [...item.pins.values()].map(pin => ({
          title: `${pin.pin} (${pin.net})`,
          key: `${item.name}::${pin.pin}`,
        }))
      }
    }).sort((a, b) => a.title.localeCompare(b.title));
    this.setState({
      treeData,
      displayTree: treeData,
      value: importData
    })
  }

  checkPins = (checkedKeys) => {
    const { value, displayTree } = this.state;
    const displayKeys = displayTree.map(tree => [{ key: tree.key }, ...(tree.children || [])]).flat(2).map(tree => tree.key)
    const { trueArray: notDisplayKeys } = splitArrayToArrays({ array: value, rule: key => !displayKeys.includes(key) })
    this.setState({
      value: [...notDisplayKeys, ...checkedKeys]
    });
  }

  searchCompAndPin = (e) => {
    const { treeData } = this.state;
    const value = e.target.value.toUpperCase();
    const _treeData = treeData.map(item => {
      if (item.title.toUpperCase().includes(value)) {
        return item
      } else if (item.children.some(child => child.title.toUpperCase().includes(value))) {
        return {
          ...item,
          children: item.children.filter(child => child.title.toUpperCase().includes(value))
        }
      }
      return null
    }).filter(item => !!item)
    this.setState({
      displayTree: _treeData
    })
  }

  closeModal = () => {
    this.props.closeModal()
  }

  importPins = () => {
    const { value } = this.state;
    this.props.importPins(value);
  }

  render() {
    const { value, displayTree } = this.state;
    const content = (
      <div>
        <Panel
          className={`port-import-panel`}
          position='panel-center-left'
          title={`Import Pins`}
          zIndex={2000}
          onCancel={() => this.closeModal()}
          width={500}
          footer={<Button key="import" onClick={this.importPins} >Import</Button>}
          draggable
        >
          <div className='port-setup-import-content'>
            <Input
              onChange={this.searchCompAndPin}
            />
            <Tree
              checkable
              checkedKeys={value}
              className='port-import-data-tree'
              treeData={displayTree}
              onCheck={this.checkPins}
            />
          </div>
        </Panel>
      </div>
    )
    return createPortal(content, this.dialogRoot)

  }
}

export default PortImport;